import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { 
    isLoggedIn: Boolean 
  }
  
  cookieYesSelectors = ['div[id^="cky-"]', 'div[class*="cky-"]'];

  connect() {
    this.moveCookieYesToPermanentContainer();
    this.handleCookiePolicyContainer();
    this.applyCookiePositioning();

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (this.isCookieYesElement(node)) {
            this.moveCookieYesToPermanentContainer();
            this.handleCookiePolicyContainer();
            this.applyCookiePositioning();
          }
        });
      });
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    ['turbo:load', 'turbo:render', 'turbo:before-cache'].forEach(eventName => {
      document.addEventListener(eventName, () => {
        this.moveCookieYesToPermanentContainer();
        this.handleCookiePolicyContainer();
        this.applyCookiePositioning();
      });
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  moveCookieYesToPermanentContainer() {
    const container = document.getElementById('cookieyes-container');
    if (!container) return;

    this.cookieYesSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (!container.contains(element) && element.id !== 'cookieyes-container') {
          container.appendChild(element);
        }
      });
    });
  }

  isCookieYesElement(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) return false;
    return this.cookieYesSelectors.some(selector => element.matches(selector));
  }

  handleCookiePolicyContainer() {
    const policyContainer = document.getElementById('cky-policy-container');
    const policyHeading = document.getElementsByClassName('cookie-policy-h1')[0];
    
    if (policyContainer) {      
      if (policyHeading) {
        policyHeading.classList.add('hidden');
      }

      const currentPath = window.location.pathname;
      policyContainer.style.display = currentPath.includes('/cookie-policy/') 
        ? 'block' 
        : 'none';
    }
  }

  applyCookiePositioning() {
    if (typeof window.matchMedia !== 'function') {
      return;
    }
    
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    
    if (!isDesktop) return;

    this.applyPositioningStyles();
    this.addOverrideClass();
  }

  addOverrideClass() {
    this.cookieYesSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.classList.add('ehc-cookie-override');
      });
    });
  }

  applyPositioningStyles() {
    const consentContainer = document.querySelector('.cky-consent-container');
    const classicBottom = document.querySelector('.cky-classic-bottom');

    if (this.isLoggedInValue) {
      if (consentContainer) {
        consentContainer.style.setProperty('width', 'calc(100% - 60px)', 'important');
        consentContainer.style.setProperty('z-index', '999', 'important');
        consentContainer.style.setProperty('pointer-events', 'auto', 'important');
      }
      
      if (classicBottom) {
        classicBottom.style.setProperty('right', '0', 'important');
        classicBottom.style.setProperty('left', 'auto', 'important');
        classicBottom.style.setProperty('z-index', '999', 'important');
        classicBottom.style.setProperty('pointer-events', 'auto', 'important')
      }
    } else {
      if (consentContainer) {
        consentContainer.style.setProperty('width', '100%', 'important');
        consentContainer.style.setProperty('z-index', '999', 'important');
        consentContainer.style.setProperty('pointer-events', 'auto', 'important');
      }
      
      if (classicBottom) {
        classicBottom.style.removeProperty('right');
        classicBottom.style.removeProperty('left');
        classicBottom.style.setProperty('z-index', '999', 'important');
        classicBottom.style.setProperty('pointer-events', 'auto', 'important');
      }
    }

    this.disableTransitions();
  }

  disableTransitions() {
    this.cookieYesSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.style.setProperty('transition', 'none', 'important');
      });
    });
  }
}